import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Kushal Sharma</span> from <span className="purple">Noida, India.</span>
            <br />
            I am currently pursuing my b.tech(cse) from <span className="purple">IILM UNIVERSITY.</span>
            <br />
            I recently completed 3 major projects: <span className="purple">Taxify, Climatecheck360, Genz-connect.</span>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> reading novels
            </li>
            <li className="about-activity">
              <ImPointRight /> Nature photography & Editing
            </li>
            <li className="about-activity">
              <ImPointRight /> chatting with friends
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Every step counts on the path to greatness."
          </p>
          <footer className="blockquote-footer">Kushal Sharma</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
